import React from 'react';
import { useLandingProduct } from 'hooks';

export default Component =>
    function withLandingProduct(props) {
        const [modelId] = useLandingProduct();

        return <Component {...props} landingProduct={{ modelId }} />;
    };
